import React from 'react';
import { BlockCustomerToggle } from '../BlockCustomerToggle';
import { Button, ButtonProps, useDataProvider, useNotify, useRecordContext, useRefresh, useResourceContext } from 'react-admin';

interface ButtonActionProps extends Omit<ButtonProps, 'onClick'> {
  onClick: (update: Function) => void;
}

const ButtonAction: React.FC<ButtonActionProps> = ({ onClick, label }) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const record = useRecordContext();
  if (!record) { return null; }

  const doUpdate = ({ resource, id, data, previousData, successMessage, errorMessage }) => {
    dataProvider.update(resource, { id, data, previousData })
      .then(() => {
        notify(successMessage);
        refresh();
      })
      .catch(() => { notify(errorMessage, { type: 'warning' }); })
  }

  return (
    <Button
      label={label}
      onClick={(event) => {
        event.stopPropagation();
        onClick(doUpdate);
      }}
    />
  );
}

export const BlockCustomerButton: React.FC<ButtonProps> = () => {
  const record = useRecordContext();
  if (!record) { return null; }

  return <BlockCustomerToggle customer={record.customer} />;
}

export const IgnoreFraudButton: React.FC<ButtonProps> = () => {
  const record = useRecordContext();
  const resource = useResourceContext();
  if (!record || !resource) { return null; }

  const { isIgnored } = record;

  return (
    <ButtonAction
      disabled={isIgnored}
      label={isIgnored ? 'Ignorada' : 'Ignorar'}
      onClick={(update) =>
        update({
          resource: resource,
          id: record.id,
          data: { isIgnored: true },
          previousData: record,
          successMessage: 'Possível fraude ignorada',
          errorMessage: 'Erro ao ignorar possível fraude'
        })
      }
    />
  );
}

export const IgnoreCustomerFraudButton: React.FC<ButtonProps> = () => {
  const record = useRecordContext();
  if (!record) { return null; }

  let { customer } = record;

  if (!customer) {
    customer = record;
  }

  return (
    <ButtonAction
      label={customer.ignoreFraud ? 'Considerar novamente' : 'Ignorar Sempre'}
      onClick={(update) => {
        const successMessage = `Cliente ${customer.ignoreFraud ? 'removido da' : 'adicionado à'} lista branca`;
        const errorMessage = `Erro ao ${customer.ignoreFraud ? 'remover cliente da' : 'adicionar cliente à'} lista branca`;
        update({
          resource: 'customers',
          id: customer.id,
          data: { ignoreFraud: !customer.ignoreFraud },
          previousData: customer,
          successMessage,
          errorMessage
        })
      }}
    />
  );
}
